import { render, staticRenderFns } from "./Parkingspots.vue?vue&type=template&id=5f7765ce"
import script from "./Parkingspots.vue?vue&type=script&lang=js"
export * from "./Parkingspots.vue?vue&type=script&lang=js"
import style0 from "./Parkingspots.vue?vue&type=style&index=0&id=5f7765ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports